

// import React, { useState } from 'react';
// import MembershipCardImage from '../assets/PrimeMembershipImg.jpg';
// import Terms from '../T&C/Terms';

// function MembershipCard() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

//   const handleDetailsClick = () => {
//     setIsModalOpen(true);
//   };

//   const closeDetailsModal = () => {
//     setIsModalOpen(false);
//   };

//   const handlePaymentClick = () => {
//     setIsPaymentModalOpen(true);
//   };

//   const closePaymentModal = () => {
//     setIsPaymentModalOpen(false);
//   };

//   return (
//     <div className="flex justify-center items-center min-h-screen bg-gray-100 p-8">
//       <div className="border bg-white rounded-lg shadow-md w-4/5 min-h-full p-16">
//         <h2 className="text-center text-xl font-bold mb-16">SUMMARY</h2>
//         <div className="flex flex-col md:flex-row">
//           <div className="flex flex-col items-center w-full md:w-1/2 md:pr-6 mt-6 md:mt-24">
//             <img
//               src={MembershipCardImage}
//               alt="Rev Membership Card"
//               className="w-full h-auto md:h-60 object-cover mb-4 rounded"
//             />
//             <p className="text-2xl font-semibold text-center">Rev Membership Card</p>
//           </div>
//           <div className="w-full md:w-1/2 mt-6 md:mt-0 space-y-4">
//             <div className="flex justify-between text-sm md:text-base">
//               <span>Card Type:</span>
//               <span>Rev</span>
//             </div>
//             <div className="flex justify-between text-sm md:text-base">
//               <span>Amount:</span>
//               <span>₹1000.00</span>
//             </div>
//             <div className="flex justify-between text-sm md:text-base border-t">
//               <span>Wallet</span>
//             </div>
//             <div className="flex items-center text-sm md:text-base border p-3 rounded-md">
//               <input type="checkbox" className="mr-2" />
//               <span className="text-gray-600">You are eligible to use ₹100.00 of ₹100.00</span>
//               <span
//                 className="text-[#FF9630] ml-auto cursor-pointer"
//                 onClick={handleDetailsClick}
//               >
//                 Details
//               </span>
//             </div>
//             <div className="flex items-center space-x-2 text-sm md:text-base">
//               <label htmlFor="gst">I have GST Number (Optional)</label>
//             </div>
//             <div className="flex items-center text-sm md:text-base border p-2 rounded-md">
//               <input type="checkbox" className="mr-2" />
//               <span className="text-gray-600">GST IN</span>
//             </div>
//             <div className="space-y-2 text-sm md:text-base">
//               <div className="flex justify-between">
//                 <span>CGST (14%)</span>
//                 <span>₹0.00</span>
//               </div>
//               <div className="flex justify-between">
//                 <span>SGST (14%)</span>
//                 <span>₹0.00</span>
//               </div>
//             </div>
//             <div className="flex justify-between font-bold text-lg">
//               <span>Total Payable Amount</span>
//               <span>₹900.00</span>
//             </div>
//             <button
//               className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 rounded mt-4 transition"
//               onClick={handlePaymentClick}
//             >
//               MAKE PAYMENT
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* First Modal (Details) */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white rounded-lg shadow-lg w-full h-[70%] md:w-2/3 md:h-[68%] overflow-y-auto">
//             <div className="bg-[#FF9630] text-white text-center text-lg font-bold py-4 rounded-t-lg">
//               Moveonwheels Points
//             </div>
//             <div className="p-6 space-y-4 text-gray-800">
//               <ul className="list-disc pl-5 text-lg mt-8">
//                 <li>Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.</li>
//                 <li>THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES. THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.</li>
//               </ul>
//             </div>
//             <div className="text-center m-10 ">
//               <button
//                 className="bg-[#FF9630] hover:bg-[#FF9630] text-white w-full p-6 font-semibold py-3 px-6 rounded"
//                 onClick={closeDetailsModal}
//               >
//                 OKAY
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Second Modal (Payment Terms) */}
//       <Terms open={isPaymentModalOpen} onClose={closePaymentModal} />
//     </div>
//   );
// }

// export default MembershipCard;


// import React, { useState } from 'react';
// import MembershipCardImage from '../assets/PrimeMembershipImg.jpg';
// import Terms from '../T&C/Terms';

// function MembershipCard() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
//   const [isGstChecked, setIsGstChecked] = useState(false);

//   const handleDetailsClick = () => {
//     setIsModalOpen(true);
//   };

//   const closeDetailsModal = () => {
//     setIsModalOpen(false);
//   };

//   const handlePaymentClick = () => {
//     setIsPaymentModalOpen(true);
//   };

//   const closePaymentModal = () => {
//     setIsPaymentModalOpen(false);
//   };

//   const handleGstCheckbox = () => {
//     setIsGstChecked((prev) => !prev);
//   };

//   return (
//     <div className="flex justify-center items-center min-h-screen bg-gray-100 p-8">
//       <div className="border bg-white rounded-lg shadow-md w-4/5 min-h-full p-16">
//         <h2 className="text-center text-xl font-bold mb-16">SUMMARY</h2>
//         <div className="flex flex-col md:flex-row">
//           <div className="flex flex-col items-center w-full md:w-1/2 md:pr-6 mt-6 md:mt-24">
//             <img
//               src={MembershipCardImage}
//               alt="Rev Membership Card"
//               className="w-full h-auto md:h-60 object-cover mb-4 rounded"
//             />
//             <p className="text-2xl font-semibold text-center">Rev Membership Card</p>
//           </div>
//           <div className="w-full md:w-1/2 mt-6 md:mt-0 space-y-4">
//             <div className="flex justify-between text-sm md:text-base">
//               <span>Card Type:</span>
//               <span>Rev</span>
//             </div>
//             <div className="flex justify-between text-sm md:text-base">
//               <span>Amount:</span>
//               <span>₹1000.00</span>
//             </div>
//             <div className="flex justify-between text-sm md:text-base border-t">
//               <span>Wallet</span>
//             </div>
//             <div className="flex items-center text-sm md:text-base border p-3 rounded-md">
//               <input type="checkbox" className="mr-2" />
//               <span className="text-gray-600">You are eligible to use ₹100.00 of ₹100.00</span>
//               <span
//                 className="text-[#FF9630] ml-auto cursor-pointer"
//                 onClick={handleDetailsClick}
//               >
//                 Details
//               </span>
//             </div>
//             <div className="flex items-center space-x-2 text-sm md:text-base">
//               <label htmlFor="gst">I have GST Number (Optional)</label>
//             </div>
//             <div className="flex items-center text-sm md:text-base border p-2 rounded-md">
//               <input
//                 type="checkbox"
//                 className="mr-2"
//                 onChange={handleGstCheckbox}
//                 checked={isGstChecked}
//               />
//               <span className="text-gray-600">GST IN</span>
//             </div>
//             {isGstChecked && (
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//                 <div>
//                   <input
//                     type="text"
//                     id="gstin"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter GST IN"
//                   />
//                 </div>
//                 <div>
//                   <input
//                     type="text"
//                     id="businessName"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter Business Name"
//                   />
//                 </div>
//                 <div>
//                   <input
//                     type="text"
//                     id="businessAddress"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter Business Address"
//                   />
//                 </div>
//                 <div>
//                   <input
//                     type="email"
//                     id="businessEmail"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter Business Email"
//                   />
//                 </div>
//               </div>
//             )}
//             <div className="space-y-2 text-sm md:text-base">
//               <div className="flex justify-between">
//                 <span>CGST (14%)</span>
//                 <span>₹0.00</span>
//               </div>
//               <div className="flex justify-between">
//                 <span>SGST (14%)</span>
//                 <span>₹0.00</span>
//               </div>
//             </div>
//             <div className="flex justify-between font-bold text-lg">
//               <span>Total Payable Amount</span>
//               <span>₹900.00</span>
//             </div>
//             <button
//               className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 rounded mt-4 transition"
//               onClick={handlePaymentClick}
//             >
//               MAKE PAYMENT
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* First Modal (Details) */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white rounded-lg shadow-lg w-full h-[70%] md:w-2/3 md:h-[68%] overflow-y-auto">
//             <div className="bg-[#FF9630] text-white text-center text-lg font-bold py-4 rounded-t-lg">
//               Moveonwheels Points
//             </div>
//             <div className="p-6 space-y-4 text-gray-800">
//               <ul className="list-disc pl-5 text-lg mt-8">
//                 <li>Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.</li>
//                 <li>THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES. THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.</li>
//               </ul>
//             </div>
//             <div className="text-center m-10">
//               <button
//                 className="bg-[#FF9630] hover:bg-[#FF9630] text-white w-full p-6 font-semibold py-3 px-6 rounded"
//                 onClick={closeDetailsModal}
//               >
//                 OKAY
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Second Modal (Payment Terms) */}
//       <Terms open={isPaymentModalOpen} onClose={closePaymentModal} />
//     </div>
//   );
// }

// export default MembershipCard;



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import MembershipCardImage from '../assets/PrimeMembershipImg.jpg';
import Terms from '../T&C/Terms';

function MembershipCard() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isGstChecked, setIsGstChecked] = useState(false);
  const navigate = useNavigate(); // Initialize navigate

  const handleDetailsClick = () => {
    setIsModalOpen(true);
  };

  const closeDetailsModal = () => {
    setIsModalOpen(false);
    navigate('/booking-summary'); // Redirect to the next page when OKAY is clicked
  };

  const handlePaymentClick = () => {
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  const handleGstCheckbox = () => {
    setIsGstChecked((prev) => !prev);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 md:p-8">
      <div className="border bg-white rounded-lg shadow-md md:w-4/5  min-h-full md:p-16 p-6">
        <h2 className="text-center text-xl font-bold md:mb-16 mb-4">SUMMARY</h2>
        <div className="flex flex-col md:flex-row">
          <div className="flex flex-col items-center w-full md:w-1/2 md:pr-6 mt-6 md:mt-24">
            <img
              src={MembershipCardImage}
              alt="Rev Membership Card"
              className="w-full h-auto md:h-60 object-cover mb-4 rounded"
            />
            <p className="text-2xl font-semibold text-center">Rev Membership Card</p>
          </div>
          <div className="w-full md:w-1/2 mt-6 md:mt-0 space-y-4">
            <div className="flex justify-between text-sm md:text-base">
              <span>Card Type:</span>
              <span>Rev</span>
            </div>
            <div className="flex justify-between text-sm md:text-base">
              <span>Amount:</span>
              <span>₹1000.00</span>
            </div>
            <div className="flex justify-between text-sm md:text-base border-t">
              <span>Wallet</span>
            </div>
            <div className="flex items-center text-sm md:text-base border p-3 rounded-md">
              <input type="checkbox" className="mr-2" />
              <span className="text-gray-600">You are eligible to use ₹100.00 of ₹100.00</span>
              <span
                className="text-[#FF9630] ml-auto cursor-pointer"
                onClick={handleDetailsClick}
              >
                Details
              </span>
            </div>
            <div className="flex items-center space-x-2 text-sm md:text-base">
              <label htmlFor="gst">I have GST Number (Optional)</label>
            </div>
            <div className="flex items-center text-sm md:text-base border p-2 rounded-md">
              <input
                type="checkbox"
                className="mr-2"
                onChange={handleGstCheckbox}
                checked={isGstChecked}
              />
              <span className="text-gray-600">GST IN</span>
            </div>
            {isGstChecked && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div>
                  <input
                    type="text"
                    id="gstin"
                    className="mt-1 p-2 block w-full border rounded-md"
                    placeholder="Enter GST IN"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    id="businessName"
                    className="mt-1 p-2 block w-full border rounded-md"
                    placeholder="Enter Business Name"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    id="businessAddress"
                    className="mt-1 p-2 block w-full border rounded-md"
                    placeholder="Enter Business Address"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    id="businessEmail"
                    className="mt-1 p-2 block w-full border rounded-md"
                    placeholder="Enter Business Email"
                  />
                </div>
              </div>
            )}
            <div className="space-y-2 text-sm md:text-base">
              <div className="flex justify-between">
                <span>CGST (14%)</span>
                <span>₹0.00</span>
              </div>
              <div className="flex justify-between">
                <span>SGST (14%)</span>
                <span>₹0.00</span>
              </div>
            </div>
            <div className="flex justify-between font-bold text-lg">
              <span>Total Payable Amount</span>
              <span>₹900.00</span>
            </div>
            <button
              className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 rounded mt-4 transition"
              onClick={handlePaymentClick}
            >
              MAKE PAYMENT
            </button>
          </div>
        </div>
      </div>

      {/* First Modal (Details) */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-2">
          <div className="bg-white rounded-lg shadow-lg w-full h-[70%] md:w-2/3 md:h-[68%] overflow-y-auto">
            <div className="bg-[#FF9630] text-white text-center text-lg font-bold py-4 rounded-t-lg">
              Moveonwheels Points
            </div>
            <div className="p-6 space-y-4 text-gray-800">
              <ul className="list-disc pl-5 text-lg mt-8 ">
                <li>Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.</li>
                <li>THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES. THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.</li>
              </ul>
            </div>
            <div className="text-center m-10">
              <button
                className="bg-[#FF9630] hover:bg-[#FF9630] text-white w-full p-6 font-semibold py-3 px-6 rounded"
                onClick={closeDetailsModal}
              >
                OKAY
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Second Modal (Payment Terms) */}
      <Terms open={isPaymentModalOpen} onClose={closePaymentModal} />
    </div>
  );
}

export default MembershipCard;
